import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { removeFileUpload, updateFileUpload } from '../../../../vtfileupload-moderation/slice';
import { IconClose, IconDownload, IconError, IconLoading, IconRefresh, IconSuccess } from '../../../icons/svg';
import Attachment from './Attachment';
import Tooltip from '../../../tooltip/components/Tooltip';
import Icon from '../../../icons/components/Icon';
import { humanFileSize } from '../../functions';
import { MESSAGE_TYPE_LOCAL } from '../../../../chat/constants';
const Attachments = ({ attachments, haveText }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const genLastElement = (attachments) => {
        if (attachments?.length &&
            !attachments[attachments.length - 1].type?.includes('video') &&
            !attachments[attachments.length - 1].type?.includes('audio') &&
            !attachments[attachments.length - 1].type?.includes('image')) {
            return React.createElement("div", { style: { height: '5px', marginBottom: haveText ? "-15px" : 0 } });
        }
        return null;
    };
    const renderAttachmentStatus = (attachment) => {
        if (!attachment.status || attachment.status === "uploaded") {
            if (attachment.isPending || (!attachment.status && attachment.messageType !== MESSAGE_TYPE_LOCAL)) {
                return null;
            }
            return React.createElement(Icon, { className: "action-icon attachIcon", size: 14, src: IconSuccess });
        }
        else if (attachment.status === "error") {
            return (React.createElement(Tooltip, { content: t(`chat.errors.${attachment.errorType}`, {
                    errorMessage: attachment.errorType === "file-too-large" ? humanFileSize(Number(attachment.errorMessage), false) : attachment.errorMessage
                }) },
                React.createElement(Icon, { className: "action-icon attachIcon", size: 14, src: IconError })));
        }
        else {
            return React.createElement(Icon, { className: "action-icon attachIcon loading", size: 14, src: IconLoading });
        }
    };
    return (React.createElement("div", { className: "attachments-holder" },
        attachments?.map((attachment) => (attachment.name ? (React.createElement("div", { className: "attachment-item-holder", style: { position: 'relative' }, key: attachment.id },
            (attachment.type?.includes('video') || attachment.type?.includes('image') || attachment.type?.includes('audio')) && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "attachment-status" }, renderAttachmentStatus(attachment)),
                React.createElement("div", { className: "action-holder" },
                    attachment.isPending && attachment.status === "error" && attachment.errorType === "when-upload" && (React.createElement(Tooltip, { content: t(`chat.attachActions.reupload`), position: "top" },
                        React.createElement(Icon, { className: "action-icon attachIcon", size: 18, src: IconRefresh, onClick: () => dispatch(updateFileUpload({ ...attachment, status: "ready" })) }))),
                    (!attachment.status || attachment.status === "uploaded") && (React.createElement(Tooltip, { content: t(`chat.attachActions.download`), position: "top" },
                        React.createElement("a", { href: `${attachment.url}?download=1`, target: "_blank", rel: "noreferrer", download: attachment.name },
                            React.createElement(Icon, { className: "action-icon attachIcon", size: 18, src: IconDownload })))),
                    attachment.isPending && (React.createElement(Tooltip, { content: t(`chat.attachActions.remove`), position: "top" },
                        React.createElement(Icon, { className: "action-icon attachIcon", size: 18, src: IconClose, onClick: () => dispatch(removeFileUpload([attachment.id])) })))),
                React.createElement("div", { className: "action-back", style: { width: '18px', height: '0px' } }))),
            React.createElement(Attachment, { attachment: attachment }))) : null)),
        genLastElement(attachments)));
};
export default Attachments;
